import { gql } from "@apollo/client";

export const HEAD_TITLE_FRAGMENT = gql`
  fragment HeadTitle on ComponentGeneralHeadTitle {
    Subtitle
    Description
    Title
  }
`;
